
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.059 4.445c-2.141-1.825-5.325-1.497-7.29.53L12 5.77l-.769-.793C9.27 2.948 6.082 2.62 3.941 4.445c-2.453 2.093-2.582 5.851-.387 8.12l7.559 7.806a1.225 1.225 0 001.77 0l7.558-7.805c2.2-2.27 2.07-6.028-.382-8.121z","fill":"#525F7F"}})])
          )
        }
      }
    